import React from 'react';
import { WORKDAY_ACCOUNTS } from '../../messages';
import { AuthenticatedHeader } from '../authenticatedHeader/authenticated-header';
import './authenticated-page-container.scss';
import { MenuContentFn } from '../headerMenu/HeaderMenu';

interface AuthenticatedPageContainerProps {
    profileImageUrl?: string;
    faqUrl?: string;
    variant?: 'inverse';
    onLogoClick?: () => void;
    footer?: React.ReactNode;
    menuContent: MenuContentFn;
    children?: React.ReactNode;
}

export const AuthenticatedPageContainer = ({
    profileImageUrl,
    faqUrl,
    variant,
    onLogoClick,
    footer,
    menuContent,
    children
}: AuthenticatedPageContainerProps) => {
    return (
        <div className='authenticatedPageContainer'>
            <AuthenticatedHeader
                title={WORKDAY_ACCOUNTS}
                profileImageUrl={profileImageUrl}
                faqUrl={faqUrl}
                variant={variant}
                onLogoClick={onLogoClick}
                menuContent={menuContent}
            />
            <main className='authenticatedPageContainer__main'>{children}</main>
            {footer}
        </div>
    );
};
